"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumTags = exports.getTagText = exports.DisplayedTags = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var ProjectTypes_1 = require("Project/ProjectTypes");
var StringManipulater_1 = require("Utils/StringManipulater");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BASE_CLASS_NAME = "displayed-tags";
var Archived = ProjectTypes_1.SpecialProjectTag.Archived, Starred = ProjectTypes_1.SpecialProjectTag.Starred, Template = ProjectTypes_1.SpecialProjectTag.Template;
var specialTags = [Archived, Starred, Template];
exports.DisplayedTags = (0, mobx_react_1.observer)(function (props) {
    var _a;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(BASE_CLASS_NAME, (_a = {},
            _a["".concat(BASE_CLASS_NAME, "--no-tags")] = !(0, exports.getNumTags)(props.tags),
            _a)) },
        react_1.default.createElement(icons_1.Tag, { className: "".concat(BASE_CLASS_NAME, "__tag-img") }),
        (0, exports.getTagText)(props.tags)));
});
var getTagText = function (tags) {
    var displayedTags = (0, lodash_1.difference)(tags, specialTags);
    if (displayedTags.length === 1) {
        return displayedTags[0];
    }
    else {
        return (0, StringManipulater_1.pluralise)(displayedTags.length, "tag", undefined, "no");
    }
};
exports.getTagText = getTagText;
var getNumTags = function (tags) {
    return (0, lodash_1.difference)(tags, specialTags).length;
};
exports.getNumTags = getNumTags;
exports.default = exports.DisplayedTags;
